import { render, staticRenderFns } from "./LogosTable.vue?vue&type=template&id=5da33832"
import script from "./LogosTable.vue?vue&type=script&lang=js"
export * from "./LogosTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports